module.exports = __webpack_public_path__ + "img/logo.fc7745e0.png";